import { FC, HTMLAttributes, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Flex, Typography } from 'antd';
import { TextProps } from 'antd/es/typography/Text';

import AvailableIcon from 'assets/images/finances/available.svg?react';
import HoldIcon from 'assets/images/finances/hold.svg?react';
import ReportsIcon from 'assets/images/menu/reports.svg?react';
import { EActionReportStatuses, EReportTypes } from 'entities/Report';
import { EFilters } from 'features/Filters';
import { useCommonSlice } from 'shared/hooks';
import { EMainRoutes } from 'shared/typings';
import { formatNumber } from 'shared/utils';

import styles from './BalanceItem.module.scss';

interface IBalanceItemProps extends HTMLAttributes<HTMLDivElement> {
	balance: string;
	currency: string;
	type: 'approve' | 'hold';
}

interface IType {
	color: TextProps['type'];
	title: string;
	icon: ReactNode;
	link: string;
}

export const BalanceItem: FC<IBalanceItemProps> = ({ balance, currency, type, ...props }) => {
	const { t } = useTranslation();
	const { currenciesMap } = useCommonSlice();

	const types: Record<typeof type, IType> = {
		approve: {
			color: undefined,
			title: t('Подтвержден, доступен для вывода'),
			icon: <AvailableIcon />,
			link: `/${EMainRoutes.REPORTS}?${EFilters.REPORT_TYPE}=${EReportTypes.ACTION}&${EFilters.STATUS}=${EActionReportStatuses.READY_FOR_WITHDRAWAL}`,
		},
		hold: {
			color: 'secondary',
			title: t('Подтвержден, ожидает оплаты рекламодателя'),
			icon: <HoldIcon />,
			link: `/${EMainRoutes.REPORTS}?${EFilters.REPORT_TYPE}=${EReportTypes.ACTION}&${EFilters.STATUS}=${EActionReportStatuses.AWAITING_PAYMENT}&${EFilters.STATUS}=${EActionReportStatuses.AWAITING_CONFIRMATION}`,
		},
	};

	return (
		<Flex {...props} gap={8} align="center">
			{types[type].icon}

			<Flex vertical>
				<Typography.Text type="secondary" style={{ fontSize: 12 }}>
					{types[type].title}
				</Typography.Text>

				<Flex gap={8} align="center">
					<Typography.Text type={types[type].color} strong style={{ fontSize: 20 }}>
						{formatNumber(balance)} {currenciesMap[currency]}
					</Typography.Text>
					<Link className={styles.link} to={types[type].link}>
						<ReportsIcon />
					</Link>
				</Flex>
			</Flex>
		</Flex>
	);
};
